import { User } from '../auth/User';
import { ApiResponse } from './ApiResponse';
import { ApiRoutes, getFullApiRoute, OnboardingApiBaseRoot, OnboardingApiRoutes, replaceRouteParams } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';

export interface AiOnboardingLink {
  id: string;
  companyId: string;
  status: 'active' | 'expired';
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  expiresAt: string | null;
}

export class AiOnboardingLinksAPI {
  static async getActiveToken(
    user: User | null,
    companyId: string,
  ): Promise<(ApiResponse & { data: AiOnboardingLink }) | undefined> {
    const url = getFullApiRoute(
      replaceRouteParams(ApiRoutes.AI_ONBOARDING_LINKS_GENERATE_V3, { companyId }),
    );
    const result = await HttpRequest(url, 'GET', null, null, user);
    return result && result.data && result.data?.id ? (result as ApiResponse & { data: AiOnboardingLink }) : undefined;
  }

  static async createLink(
    user: User | null,
    companyId: string,
    neverExpires: boolean = false,
  ): Promise<(ApiResponse & { data: AiOnboardingLink }) | undefined> {
    const url = getFullApiRoute(
      replaceRouteParams(ApiRoutes.AI_ONBOARDING_LINKS_GENERATE_V3, { companyId }),
    );
    const result = await HttpRequest(url, 'POST', { neverExpires }, null, user);
    return result && result.data && result.data?.id ? (result as ApiResponse & { data: AiOnboardingLink }) : undefined;
  }

  /**
   * Syncs the onboarding data for a company to CMS tokens.
   * Uses a separate onboarding service base URL (OnboardingApiBaseRoot / NX_PUBLIC_ONBOARDING_API_ENDPOINT).
   */
  static async syncOnboardingToCmsTokens(
    user: User | null,
    companyId: string,
  ): Promise<ApiResponse | undefined> {
    const url = `${OnboardingApiBaseRoot}${replaceRouteParams(OnboardingApiRoutes.AI_ONBOARDING_SYNC_CMS_TOKENS, { companyId })}`;
    const result = await HttpRequest(url, 'POST', null, null, user);
    return result ?? undefined;
  }
}
